// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1pD5Z","label":"Radio_label__1VIrZ","checkMark":"Radio_checkMark__2K10Z","disabled":"Radio_disabled__8Iq4I"};